import { BybButton } from "@Components/common/byb-ds";
import { useNotificationDialog } from "@Context/common/general/notification-dialog-context";
import useI18n from "@i18n";
import { Button, Stack, Typography } from "@mui/material";
import BybDialog from "./byb-vr-dialog";

const notificationTypeIcons = {
  success: "🤩",
  error: "😖",
  warning: "⚠️",
  info: "ℹ️",
};

const VRNotificationDialog = () => {
  const { i18n } = useI18n();
  const { isVisible, currentNotification, hideNotification } = useNotificationDialog();

  if (!currentNotification) return null;

  const { type, title, message } = currentNotification;

  return (
    <BybDialog
      name="VRNotificationDialog"
      open={isVisible}
      onClose={() => hideNotification()}
      aria-labelledby="notification-dialog-title"
      aria-describedby="notification-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <Stack spacing={3}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography fontSize={32}>{notificationTypeIcons[type]}</Typography>
          <Typography variant="text3xl600" color="dsBase.v200">
            {title}
          </Typography>
          <Typography variant="text1xl500" color="dsNeutral.v300">
            {message}
          </Typography>
        </Stack>
        <Button onClick={() => hideNotification()} size="large">
          {i18n("close")}
        </Button>
      </Stack>
    </BybDialog>
  );
};

export default VRNotificationDialog;
